const COLORS = {
  false: '#f44336',
  true: '#389aef',
};

export default status => COLORS[status];